import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Divider,
  Grid,
  Header,
  Input,
  Segment,
  Message,
} from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { closeModal } from "../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../app/common/modals/modalWrapper";
import {
  updateDocInDb,
  updateNotificationsDocNameForDocInDb,
} from "../../../app/firestore/firestoreService";
import { isValidName } from "../../../app/common/util/util";

export default function DocRenameModal({ doc }) {
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const dispatch = useDispatch();
  const [textInput, setTextInput] = useState(doc.name);
  const [validationError, setValidationError] = useState("");
  const inputRef = useRef(null);

  function handleTextInputChange(event) {
    let value = event.target.value;
    // Replace multiple consecutive spaces with single space
    value = value.replace(/\s+/g, ' ');
    setTextInput(value);

    // Clear validation error when user starts typing
    if (validationError) {
      setValidationError("");
    }
  }

  async function handleSubmit() {
    // Validate the input
    if (!textInput.trim()) {
      setValidationError("Name cannot be empty");
      return;
    }

    if (!isValidName(textInput.trim())) {
      setValidationError("Name can only contain letters, numbers, underscores, parentheses, dashes, and spaces");
      return;
    }

    try {
      const updatedDocName = textInput.trim();
      await updateDocInDb(doc.id, { name: updatedDocName }, true);
      await updateNotificationsDocNameForDocInDb(doc.id, updatedDocName);
      dispatch(
        closeModal({
          modalType: "DocRenameModal",
        })
      );
    } catch (error) {
      throw error;
    }
  }

  return (
    <>
      <ModalWrapper size="small">
        <Segment>
          <Grid>
            <Grid.Column>
              <Header size="large" color="blue">
                Rename Document
              </Header>
              <Divider />
              <Input
                fluid
                ref={inputRef}
                value={textInput}
                onChange={handleTextInputChange}
                error={!!validationError}
              ></Input>
              {validationError && (
                <Message negative size="small">
                  {validationError}
                </Message>
              )}
              <Divider />
              <div>
                <Button
                  primary
                  type="submit"
                  onClick={() => handleSubmit()}
                  floated={isMobile ? null : "right"}
                  content="Submit"
                  className={isMobile ? "fluid medium bottom margin" : null}
                />
                <Button
                  type="button"
                  onClick={() =>
                    dispatch(
                      closeModal({
                        modalType: "DocRenameModal",
                      })
                    )
                  }
                  floated={isMobile ? null : "right"}
                  content="Cancel"
                  className={isMobile ? "fluid medium bottom margin" : null}
                />
              </div>
            </Grid.Column>
          </Grid>
        </Segment>
      </ModalWrapper>
    </>
  );
}
